import { create } from 'zustand';

const STORAGE_KEY = 'usarules_language'; // same manual localStorage pattern as store/authStore.js

/**
 * Frontend Language Switcher & persistence (Multi-Language Translation
 * Pipeline, client half). 'en' (the original, always-present text) plus the
 * 8 codes in shared/constants.js's TRANSLATION_LANGUAGES. Persisted to
 * localStorage so the choice survives a reload/new session, same rationale
 * authStore.js documents for persisting the auth token there.
 */
function loadPersisted() {
  try {
    return window.localStorage.getItem(STORAGE_KEY) || 'en';
  } catch {
    return 'en';
  }
}

function persist(language) {
  try {
    window.localStorage.setItem(STORAGE_KEY, language);
  } catch {
    /* ignore quota errors */
  }
}

export const useLanguageStore = create((set) => ({
  language: loadPersisted(),
  setLanguage: (language) => {
    persist(language);
    set({ language });
  },
}));
